module.exports = __webpack_public_path__ + "img/园区-选中.f384553b.png";